import React from 'react';
import { StyledComponentProps, withStyles } from '@material-ui/core';
import { IconButton as MuiButton } from '@material-ui/core';
import { styles } from './styles';
import { ReactComponent as Delete } from '../../images/icons/delete.svg';
import clsx from 'clsx';

interface IProps extends StyledComponentProps {
    onClick: (evt: any) => any;
    disabled?: boolean;
    className?: any;
}

//const DeleteIconButton = (props: IProps) => {
const DeleteIconButton = React.forwardRef((props: IProps, ref: any) => {
    return <MuiButton
        innerRef={ref}
        disabled={props.disabled}
        className={props.className ? clsx(props.className, props.classes.iconButtonRootSvgBlack) : props.classes.iconButtonRootSvgBlack}
        onClick={props.onClick}>
        <div>
            <Delete className={props.classes.iconButtonSvgBlack} />
        </div>
    </MuiButton>
});


export default withStyles(styles)(DeleteIconButton)